import { isIframe } from '@/lib/utils';

function translationManager() {
  return isIframe() ? 'iframeTranslationManager' : 'browserTranslationManager';
}

const getters = {
  translationStatus: (_state, _getters, rootState) =>
    rootState[`${translationManager()}`].translationStatus
};

const actions = {
  call: ({ dispatch }, { method, args }) => {
    dispatch(`${translationManager()}/${method}`, args, { root: true });
  }
};

export default { namespaced: true, getters, actions };
